import { $ } from '@starberry/components';
import React from 'react';
import { StackDivider } from "@chakra-ui/react"

const FooterMenu = {
    $: 'Flex',
    menus: [
        { label: 'Term of Use', link: '#' },
        { label: 'Privacy Policy & Notice', link: '#' },
    ],
    children: ({ menus }) => {
        return [
            {
                $: 'Stack',
                props: {
                    direction: 'row'
                },
                children: menus.map(({label, link, props}) => {
                    return {
                        $: 'WrappedLink',
                        props: {
                            href: link,
                            target: '_blank',
                            color: $('constants.colors.grey2'),
                            fontSize: 'sm',
                            borderRight: `1px solid rgba(0, 0, 0, 0.2)`,
                            paddingRight: '5px',
                            _last: {
                                borderRight: 'none',
                            },
                            ...props,
                        },
                        children: label,
                    };
                }),
            },
        ];
    },
}

export default FooterMenu;